import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useFetch from 'Hooks/useFetch';
import useToastNotifications from 'Hooks/useToastNotifications';
import { API_EXCHANGE_RATES } from 'Constants';

const useExchangeRates = () => {
  const { t } = useTranslation();
  const fetcher = useFetch();
  const toast = useToastNotifications();
  const [exchangeRates, setExchangeRates] = useState([]);
  const [exchangeRatesLoading, setExchangeRatesLoading] = useState(true);
  const notificationRef = useRef(toast.addNotification);
  const translationRef = useRef(t);

  useEffect(() => {
    notificationRef.current = toast.addNotification;
  }, [toast.addNotification]);

  useEffect(() => {
    translationRef.current = t;
  }, [t]);

  useEffect(() => {
    let isActive = true;
    setExchangeRatesLoading(true);

    fetcher(API_EXCHANGE_RATES)
      .then(response => {
        if (!isActive) return;
        setExchangeRates(response?.exchangeRates || response?.data?.exchangeRates || []);
      })
      .catch(error => {
        if (!isActive || error?.code === 20) return;
        setExchangeRates([]);
        notificationRef.current({
          type: 'error',
          title: error?.info?.errors?.at(0)?.message
            || error?.message
            || translationRef.current('offers.exchangeRatesFailed')
        });
      })
      .finally(() => {
        if (isActive) setExchangeRatesLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [fetcher]);

  return { exchangeRates, exchangeRatesLoading };
};

export default useExchangeRates;
